import maintenancePage from '../../assets/content/maintenancePage.json';

export function getMaintenanceContent() {
  return maintenancePage;
}
